import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type HomePageAccountCreationCardProps = {
  className?: string
  title: string
  description: string
  button: ActionButtonProps
  image?: ImageProps
}

const HomePageAccountCreationCard: FC<HomePageAccountCreationCardProps> = ({
  className,
  title,
  description,
  button,
  image,
}) => {
  return (
    <SC.HomePageAccountCreationCard
      className={cx('HomePageAccountCreationCard', className)}
    >
      <SC.LeftContent>
        <SC.Title>{title}</SC.Title>
        <SC.Description>{description}</SC.Description>
        <SC.Button {...button} />
      </SC.LeftContent>
      <SC.RightContent>{image && <SC.Img {...image} />}</SC.RightContent>
    </SC.HomePageAccountCreationCard>
  )
}

export default HomePageAccountCreationCard
